module.exports = __webpack_public_path__ + "img/visa.b38d70b1.svg";